import { connect } from 'react-redux'
//components/MaintenanceFixComponent
import MaintenanceAuditComponent from '../components/MaintenanceAuditComponent.jsx';
import {
	forwardToFindAuditableMCases,
    forwardToAssignAuditingTarget,
} from '../actions';

const mapStateToProps = (state) => ({

	request: state.getIn(['maintenanceAuditingReducer', 'request']),
	response: state.getIn(['maintenanceAuditingReducer', 'response']),
	options: state.getIn(['maintenanceAuditingReducer', 'options']),

})

const mapDispatchToProps = (dispatch) => ({
	findAuditableMCases: () => {
		dispatch(forwardToFindAuditableMCases());
	},
	assignModifyingTarget: (mcase) => {
		dispatch(forwardToAssignAuditingTarget(mcase));
	},
})

const MaintenanceAuditContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceAuditComponent)

export default MaintenanceAuditContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceAuditContainer.jsx